import React, { useEffect, useRef } from 'react';
import { isFxLite } from '@utils/fxLite';
import { initBgFX } from './landingEffects';

export const FxBackground: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const lite = isFxLite();

  useEffect(() => {
    if (lite) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    return initBgFX(canvas);
  }, [lite]);

  if (lite) {
    // Phones: one gradient layer, no blur, no canvas, no hue-rotate filter.
    return <div className="fx-bg-lite pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true" />;
  }

  return (
    <div className="fx-bg pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" />
      <div className="bg-motion" />
      <div className="bg-mesh" />
      <div className="blob -top-40 -left-32 w-[42rem] h-[42rem] bg-brand/25 blur-[140px]" style={{ animation: 'drift1 26s ease-in-out infinite' }} />
      <div className="blob top-1/4 -right-44 w-[40rem] h-[40rem] bg-indigo-600/20 blur-[150px]" style={{ animation: 'drift2 32s ease-in-out infinite' }} />
      <div className="blob bottom-1/4 left-1/4 w-[36rem] h-[36rem] bg-cyan-500/12 blur-[150px]" style={{ animation: 'drift3 30s ease-in-out infinite' }} />
      <div className="blob bottom-0 right-1/4 w-[32rem] h-[32rem] bg-blue-600/16 blur-[150px]" style={{ animation: 'drift1 36s ease-in-out infinite reverse' }} />
    </div>
  );
};
